import { Component, input } from '@angular/core';
import { faEllipsis, faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'eiq-actions-menu',
  templateUrl: './actions-menu.component.html',
  styleUrls: ['./actions-menu.component.scss']
})
export class ActionsMenuComponent {
  actions = input<any>();
  orientation = input<'vertical' | 'horizontal'>('vertical');
  size = input<'default' | 'small'>('default');
  testId = input<string>();

  faEllipsis = faEllipsis;
  faEllipsisVertical = faEllipsisVertical;
}
